import { useEffect, useState } from "react";
import PageShell from "@/components/PageShell";
import api from "@/lib/api";
import { formatRupiah, formatNumber } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Download } from "lucide-react";

export default function Reports() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/dashboard?period=year").then((r) => setData(r.data)); }, []);

  const download = (type) => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/reports/export?type=${type}`;
    fetch(url, { credentials: "include" }).then((r) => r.blob()).then((blob) => {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `${type}.csv`;
      a.click();
    });
  };

  return (
    <PageShell title="Laporan & Export">
      <div className="flex flex-wrap gap-3">
        <Button variant="outline" onClick={() => download("invoices")} data-testid="export-invoices-csv"><Download className="h-4 w-4 mr-1.5" />Export Nota (CSV)</Button>
        <Button variant="outline" onClick={() => download("schedules")} data-testid="export-schedules-csv"><Download className="h-4 w-4 mr-1.5" />Export Jadwal (CSV)</Button>
        <Button variant="outline" onClick={() => download("returns")} data-testid="export-returns-csv"><Download className="h-4 w-4 mr-1.5" />Export Retur (CSV)</Button>
      </div>

      {data && (
        <>
          <div className="grid gap-4 grid-cols-2 lg:grid-cols-4">
            <Metric label="Pembelian Tahun Ini (Roll)" value={formatNumber(data.purchases.year.rolls)} />
            <Metric label="Nilai Pembelian Tahun Ini" value={formatRupiah(data.purchases.year.value)} />
            <Metric label="Total Utang Bersih" value={formatRupiah(data.net_debt)} />
            <Metric label="Kredit Supplier Tersedia" value={formatRupiah(data.available_credit)} />
            <Metric label="Total Lunas (Roll)" value={formatNumber(data.paid_vs_unpaid.paid_rolls)} />
            <Metric label="Total Lunas (Nilai)" value={formatRupiah(data.paid_vs_unpaid.paid_value)} />
            <Metric label="Bayar via Transfer" value={formatRupiah(data.net_payment.transfer)} />
            <Metric label="Bayar via Giro" value={formatRupiah(data.net_payment.giro)} />
          </div>

          <Card className="shadow-sm"><CardHeader><CardTitle className="text-base">Ranking Supplier (Roll & Nilai Pembelian)</CardTitle></CardHeader>
            <CardContent className="p-0">
              <Table>
                <TableHeader><TableRow><TableHead>#</TableHead><TableHead>Supplier</TableHead><TableHead className="text-right">Roll</TableHead><TableHead className="text-right">Nilai Pembelian</TableHead></TableRow></TableHeader>
                <TableBody>
                  {data.ranking.map((r, i) => (
                    <TableRow key={i}><TableCell>{i + 1}</TableCell><TableCell className="font-medium">{r.name}</TableCell>
                      <TableCell className="text-right font-mono">{formatNumber(r.rolls)}</TableCell>
                      <TableCell className="text-right font-mono font-semibold">{formatRupiah(r.value)}</TableCell></TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </>
      )}
    </PageShell>
  );
}

function Metric({ label, value }) {
  return (
    <Card className="shadow-sm"><CardContent className="p-4">
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</div>
      <div className="text-lg font-bold font-mono text-slate-900 mt-1">{value}</div>
    </CardContent></Card>
  );
}
